import { html, ifDefined } from "../../../"
import { _setFieldFocus } from "../helper"
import { _focusOutHelper } from "./helpers"
import { SYSControlBase } from "./syscontrolbase"

export class SYSCheckbox extends SYSControlBase {
  async handleChange(e: Event) {
    e.stopPropagation()
    e.preventDefault()

    let field = this.field
    let val: string | boolean = field.value

    if (val === field.ui.checkedValue) {
      if (typeof field.ui.checkedValue === "string") {
        val = field.ui.uncheckedValue
      } else {
        val = false
      }
    } else {
      if (typeof field.ui.checkedValue === "string") {
        val = field.ui.checkedValue
      } else {
        val = true
      }
    }
    await this.actions.ovl.form._ChangeField({
      fieldKey: this.field.fieldKey,
      formState: this.formState,
      value: val,
      watched: true,
      noRetrigger: true,
    })
  }

  async getUI() {
    let visible = super.InitControl()
    if (visible === false) {
      return undefined
    }
    let field = this.field
    return html`
      <div
        class="${this.getContainerClass(
          "checkbox",
          this.customInfo.customRowClassContainerName
        )}"
      >
        <ovl-controllabel .props=${() => this.field}> </ovl-controllabel>
        <div class="fd-form-item ovl-formcontrol-value __inpfocbox">
          <input
            tabindex=${ifDefined(!this.focusable ? "-1" : undefined)}
            @change=${async (e) => await this.handleChange(e)}
            @focusout=${(e) => _focusOutHelper(e, this.field)}
            @focus=${() => _setFieldFocus(field, true)}
            autocomplete="off"
            class="fd-checkbox
          ${this.getInputClass("checkbox", this.customInfo.customRowClassName)}"
            type="checkbox"
            id="${field.id}"
            ?checked=${field.value === field.ui.checkedValue}
            ?disabled=${this.getReadOnly()}
          />
          <label
            class="fd-checkbox__label ovl-formcontrol-checkbox-input ovl-value__${field.fieldKey} "
            for="${field.id}"
          >
          </label>
        </div>
        <ovl-controlcustomhint .props=${() => this.field}>
        </ovl-controlcustomhint>
        <ovl-controlvalidationhint .props=${() => this.field}>
        </ovl-controlvalidationhint>
      </div>
    `
  }
  async afterRender() {
    this.inputElement = document.getElementById(this.field.id)
    //this.inputElement.value = this.field.value
    if (this.inputElement) {
      this.inputElement.checked =
        this.field.value === this.field.ui.checkedValue
    }

    await super.afterRender()
  }
}
